/* global lib, Cookies */
function promoCode(message) {
    let interval = null;
    const closed = Cookies.get('promoCodeStop');
    const toastDuration = 7000;
    function init() {
        show();
        interval = window.setInterval(show, 10000 + toastDuration);
    }
    if (!closed) {
        setTimeout(init, 10000);
    }
    $('.toastWrap').on('click', '#promoCodeToast .closeToast', () => {
        Cookies.set('promoCodeStop', true);
        clearInterval(interval);
    });
    function show() {
        lib.ToastManager.add('promoCode', message, toastDuration);
    }
}
export default promoCode;
